import redirect from '../../utils/redirect'
import { useTranslation } from 'react-i18next'
import { Heading, Text } from '@talkdesk/cobalt-react-typography'
import { Icon } from '@talkdesk/cobalt-react-icon'
import Flex from '@talkdesk/cobalt-react-flex'
import Link from '@talkdesk/cobalt-react-link'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'

const AppLauncher = ({ name: clientName, launchUrl }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Flex direction='column' alignX='center' gap={6} paddingBottom={6}>
      <Icon name='devices' size='large' color={theme.primary600} />
      <Flex direction='column' alignX='center' gap={3}>
        <Heading level={1}>{t('appLauncher.title', { clientName })}</Heading>
        <Text size='small' color={theme.gray600}>
          {t('appLauncher.footnote', { clientName })}{' '}
          <Link target='_blank' onClick={() => redirect(launchUrl)}>
            {t('appLauncher.action')}
          </Link>
        </Text>
      </Flex>
    </Flex>
  )
}

export default AppLauncher
